module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c01-abb785bf74a219fc25058617b0d21a80.jpg";